const MAX_AGE = 50 * 60 * 1000;

export const createPackLoopsCache = ({ now = () => Date.now() } = {}) => {
  const entries = new Map();
  const get = (id, fetcher, { force = false } = {}) => {
    const existing = entries.get(id);
    if (!force && existing && now() - existing.createdAt < MAX_AGE) return existing.promise;
    const promise = Promise.resolve().then(fetcher).then((data) => data, (error) => {
      entries.delete(id);
      throw error;
    });
    entries.set(id, { createdAt: now(), promise });
    return promise;
  };
  return { get, clear: (id) => entries.delete(id), clearAll: () => entries.clear() };
};
